module.exports = __webpack_public_path__ + "img/tanker-orange.ccffdbac.svg";